module.exports = __webpack_public_path__ + "img/tspbd.6816f3bd.png";